<div class="card">
    <div class="row" style="margin: 1px;">
      <div style="margin:5px;">
        <label style="margin-right: 5px;font-weight: 600;font-size: 12px;">Filter Name:</label>
        <input type="text" [(ngModel)]="filter.FilterName" style="border: 1px solid #d2d0d0;border-radius: 5px;height: 31px;" />
      </div>
      <div style="margin:5px;">
        <label style="margin-right: 5px;font-weight: 600;font-size: 12px;">Priority:</label>
        <input type="text" [(ngModel)]="filter.Priority" style="border: 1px solid #d2d0d0;border-radius: 5px;height: 31px;"/>
      </div>

      <div style="margin:5px;">
        <label style="margin-right: 5px;font-weight: 600;font-size: 12px;">Client Code:</label>
        <label>{{filter.ClientCode}}</label>
      </div>

    </div>
</div>

  <div class="card-body" style="padding: 20px;
        border: 1px solid #d2d2d2;
        border-radius: 3px;
        box-shadow: 0px 0px 4px 3px #ababab66;
        margin: 10px;">
      <div class="row" style="margin-bottom: -8px;">
          <app-ct-query-builder (onfilter)="onfetchMore($event)" (onSearch)="onSearch($event)" (resetPage)="resetPage()"  class="margin30" [data]="query" [config]="config"  (fileChange)="onFileChange($event)" (exportExcel)="onExportExcel($event)">
          </app-ct-query-builder>
        
      </div>
  </div>
  <!-- uncoment to check the query data -->
  <!-- <textarea style="width:1000px;height:500px" >{{query | json}}</textarea> -->
  <div style="margin-right: 10px;padding-bottom: 15px;">
      <button kendoButton (click)="saveFilter(query)" style="float: right;margin: 2px;" class="btn-info.btn-outline:hover k-button k-primary"> <i class="fa fa-save"></i> Save</button>
      <button kendoButton (click)="saveAsFilter()" style="float: right;margin: 2px;" class="btn-info.btn-outline:hover k-button k-primary"> <i class="fa fa-save"></i> Save As New</button>
  </div>
  <hr>
  <div>
    <app-rule-properties (onFetch)="onfetchProperties()" [ruleLeft]="ruleLeft" [ruleRight]="ruleRight" (appliedSaveEvent)="onSaveAppliedRule($event)" (propertiesSaveEvent)="onSaveProperties($event)" (dropDownListPropEvent)="onChangeDropDownProp($event)" ></app-rule-properties>
  </div>